export default {
  // Product text configuration
  CURRENCY_UNIT_TEXT: 'Yuan',
  currencyUnit: '¥',
  OUT_OF_STOCK: 'Currently out of stock',
  OFF_THE_SHELVES: 'Discontinued',
  selected: 'Selected',
  selectAll: 'Select all',
  pickAnotherOne: 'Choose 1 more',
  DOTDPrice: 'Deal price',
  BEST_DEAL: 'Special sale gathering',
  discountPrice: 'Discount price',
  specialSalePrice: 'Special sale price',
  cheaperSinceAdded: 'Price dropped since addition',
  priceDroppedBy: 'Price dropped by ',
  sinceCartAdd: ' since cart add',
  timeRemaining: 'Ends in',
  thisItemNotInFreeShippingActivity: 'Ineligible for free shipping over ¥300',
  addToCollection: 'Move into favorites',
  removeFromCollection: 'Remove from favorites',
  share: 'Share',
  delete: 'Delete',
  piece: 'Pieces',
  discountThreeHundredMinusTwenty: 'Newcomer buy ¥{amount} get ¥{promotion}',
  DISCOUNT_THREE_HUNDRED_MINUS_TWENTY: 'Buy ¥{amount} get ¥{promotion}',
  FULL_REDUCTION_COUPON: 'Buy ¥{amount} get ¥{promotion}',
  REDUCTION_COUPON: '¥{amount} get ¥{promotion}',
  discount: 'Discount',
  numberOfGoods: 'Pieces of goods',
  priceDiscounted: 'Price has been discounted',
  salePrice: 'Special sale price',
  // Unlogged configuration
  notYetLogin: 'Dear, you are not logged in',
  goLogIn: 'Log into your Amazon account',
  // Date Display Configuration
  completeDateFormat: 'YYYY/MM/DD',
  shortDateFormat: 'MM/DD',
  DOTD: "Today's Deals",
  DEAL_OF_THE_DAY: "Today's Deals",
  myFavorites: 'My favorites',
  commented: 'Reviewed',
  toComment: 'To be reviewed',
  coupon: 'Coupons',
  favorites: 'Favorites',
  page: 'Pages',
  deliveryAddress: 'Delivery address',
  clearanceInformation: 'Customs clearance information',
  contactCS: 'Contact customer service',
  toBeShipped: 'To be shipped',
  toBeReceived: 'To be received',
  toBeCommented: 'To be reviewed',
  returnAndAfterSale: 'Return',
  myOrder: 'My orders',
  usable: 'Available',
  myCoupon: 'My coupons',
  buyGift: 'Buy and get',
  freeDelivery: 'Free shipping',
  buyMore: 'Add to buy',
  pleaseLogin: 'Please log in',
  newCustomerCoupon: 'Newcomer coupon',
  claimFailed: 'Failed to claim',
  // time
  year: 'Year',
  month: 'Month',
  day: 'Day',
  copy: 'Copy',
  copySucceed: 'Copied successful',
  COMPLETE_DATE_FORMAT: 'YYYY/MM/DD',
  SHORT_DATE_FORMAT: 'MM/DD',
  FREE_SHIPPING: 'Free shipping over ￥300',
  ELIGIBLE_FREE_SHIPPING: 'Eligible for free shipping over ￥300',
  BEST_SELLING_ITEM_RECOMMENDATION: 'Recommended best-selling items',
  DOOR_TO_DOOR_PICK_UP_AND_RETURN: 'Eligible for return',
  ELIGIBLE_FOR_RETURN: 'Eligible for return',
  DIRECT_SHIPPING: 'Sell and ship',
  AUTHENTIC_GUARANTEE: 'Authenticity guarantee',
  SOLD_BY: 'Sold by Amazon US',
  ADD_TO_CART: 'Add to Cart',
  PAY_NOW: 'Pay now ',
  AFTER_THE_COUPON_DISCOUNT: 'After coupon ',
  AFTER: 'After',
  COUPON: 'Coupon',
  SAVE: 'Save ',
  PLEASE_PROVIDE_THE_KYC_INFO: 'Please fill in the orderer',
  ONLY_REMAINING: 'Only a few left',
  COUNT: 'Quantity',
  RECOMMENDED_COMMODITIES: 'Exclusive recommendation',
  PLEASE: 'Please',
  SUCCESS_ADDED_CART: 'Added to cart',
  UP: 'Starting',
  PRODUCTS_HAVE_BEEN_SOLD_OUT: 'Item sold out',
  TODAY_DEAL: "Today's deal",
  NO_MORE: 'No more ',
  TIME_REMAINING: 'Ends in',
  AMZN: 'Amazon',
  DAYS: 'd',
  ILLUSTRATE: 'Explanation',
  ARRIVED: 'Arrived in ',
  SINGLE_PRODUCT_EXCEED_MAX_LIMIT:
    'The quantity of goods has exceeded the limit and cannot be added to the cart',
  PRODUCTS_HAVE_BEEN_SOLD_OUT_UNABLE_ADD_CART:
    'The item has sold out and cannot be added to the cart',
  SOME_PRODUCTS_ADDED_TO_CART_SUCCESSFULLY:
    'Some items have been added to the cart',
  PLEASE_LOGIN_YOUR_ACCOUNT: 'Please log in to your account first',
  PLEASE_AGREE_TO_PIPL: 'Please agree to PIPL authorization first',
  NO_ASIN_INFO: 'No product information available'
};
